import {Component, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {IShopUser} from "../../session/customer-models";
import {take} from "rxjs/operators";
import {LoginModalService} from "../../login/login-modal.service";


@Component({
    selector: 'account-switcher',
    templateUrl: './account-switcher.component.html',
    styleUrls: ['./account-switcher.component.scss'],
    standalone: false
})
export class AccountSwitcherComponent extends BaseComponent implements OnInit {
    customerId: string;
    recognitionName: string;

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
        private loginModalService: LoginModalService
    ) {
        super(userService, loggerService);

    }

    ngOnInit(): void {
        this.userService.getShopUser().subscribe((user: IShopUser) => {
            this.customerId = this.authenticated ? user.customer.id.toString() : '';
            this.recognitionName = this.authenticated ? user.customer.recognitionName : '';
        });
    }

    switchAccounts(): void {
        this.loginModalService.openLogin({isSwitchAccount: true}).pipe(take(1)).subscribe();
    }

    login(): void {
        this.loginModalService.openLogin().pipe(take(1)).subscribe();
    }

}
